import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { DocumentPreviewModule } from '@app/shared/components/document-preview/document-preview.module';
import { SharedModule } from '@app/shared/shared.module';

import { FlipcardModule, ChaptersWidgetsModule, SharedLibraryModule } from 'library-explorer';
import { SlideBucketsComponent } from './components/slide-buckets/slide-buckets.component';
import { GeneralWidgetComponent } from './components/general-widget/general-widget.component';
import { IframeFullscreenComponent } from './components/iframe-fullscreen/iframe-fullscreen.component';
import { PronunciationQuestionComponent } from './components/pronunciation-question/pronunciation-question.component';
import { QuestionBooleanComponent } from './components/question-boolean/question-boolean.component';
import { QuestionFillBlankComponent } from './components/question-fill-blank/question-fill-blank.component';
import { QuestionFreeTextComponent } from './components/question-free-text/question-free-text.component';
import { QuestionOrderingComponent } from './components/question-ordering/question-ordering.component';
import { QuestionScaleComponent } from './components/question-scale/question-scale.component';
import { QuestionSelectComponent } from './components/question-select/question-select.component';
import { QuestionSliderComponent } from './components/question-slider/question-slider.component';
import { QuestionWidgetComponent } from './components/question-widget/question-widget.component';
import { SlideBuilderSectionBackgroundComponent } from './components/slide-builder-section-background/slide-builder-section-background.component';
import { SlideBuilderSectionComponent } from './components/slide-builder-section/slide-builder-section.component';
import { SlideBuilderComponent } from './components/slide-builder/slide-builder.component';
import { SlideDocumentsComponent } from './components/slide-documents/slide-documents.component';
import { SlideImageComponent } from './components/slide-image/slide-image.component';
import { SlideScormPackageComponent } from './components/slide-scorm-package/slide-scorm-package.component';
import { SlideSpacerComponent } from './components/slide-spacer/slide-spacer.component';
import { SlideTextAudioComponent } from './components/slide-text-audio/slide-text-audio.component';
import { SlideTextVideoComponent } from './components/slide-text-video/slide-text-video.component';
import { SlideTextComponent } from './components/slide-text/slide-text.component';
import { SlideWebinarComponent } from './components/slide-webinar/slide-webinar.component';
import { VideoRecordComponent } from './components/video-record/video-record.component';
import { AudioRecordComponent } from './components/audio-record/audio-record.component';
import { ManualAssessmentFileUploadComponent } from './components/manual-assessment-question-widget/manual-assessment-file-upload/manual-assessment-file-upload.component';
import { ManualAssessmentQuestionWidgetComponent } from './components/manual-assessment-question-widget/manual-assessment-question-widget.component';
import { SlideCarouselComponent } from './components/slide-carousel/slide-carousel.component';
import { SLIDE_BUILDER_CONFIG } from './constants/injection-tokens';
import { SlideBuilderConfig } from './models/slide-builder-config';
import { SlideInstaLearnPostsComponent } from './components/slide-insta-learn-posts/slide-insta-learn-posts.component';
import { SlideInstaLearnTopicsComponent } from './components/slide-insta-learn-topics/slide-insta-learn-topics.component';
import { SlideChallengesComponent } from './components/slide-challenges/slide-challenges.component';
import { QuestionHotspotComponent } from './components/question-hotspot/question-hotspot.component';
import { SlideContentPipelineService } from './services/slide-content-pipeline.service';
import { GlossaryHtmlService } from './services/glossary-html.service';
import { SlideContentHtmlPipe } from './pipes/slide-content-html.pipe';
import { GlossaryTooltipPipe } from './pipes/glossary-tooltip.pipe';
import { ChaptersFocusModeService } from '../chapters-page/services/chapters-focus-mode.service';


const COMPONENTS = [
  SlideBucketsComponent,
  GeneralWidgetComponent,
  QuestionWidgetComponent,
  SlideImageComponent,
  SlideTextAudioComponent,
  SlideTextVideoComponent,
  SlideDocumentsComponent,
  QuestionBooleanComponent,
  QuestionFillBlankComponent,
  QuestionOrderingComponent,
  QuestionSelectComponent,
  QuestionSliderComponent,
  QuestionScaleComponent,
  SlideWebinarComponent,
  VideoRecordComponent,
  AudioRecordComponent,
  ManualAssessmentQuestionWidgetComponent,
  ManualAssessmentFileUploadComponent,
  QuestionFreeTextComponent,
  SlideBuilderComponent,
  SlideTextComponent,
  SlideSpacerComponent,
  SlideBuilderSectionComponent,
  IframeFullscreenComponent,
  SlideScormPackageComponent,
  SlideBuilderSectionBackgroundComponent,
  PronunciationQuestionComponent,
  SlideCarouselComponent,
  SlideInstaLearnPostsComponent,
  SlideInstaLearnTopicsComponent,
  SlideChallengesComponent,
  QuestionHotspotComponent
];

const PIPES = [
  SlideContentHtmlPipe, 
  GlossaryTooltipPipe
]

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    DocumentPreviewModule,
    SharedLibraryModule,
    FlipcardModule,
    ChaptersWidgetsModule
  ],
  exports: [
    ...COMPONENTS,
    ...PIPES
  ],
  declarations: [
    ...COMPONENTS,
    ...PIPES
  ],
  providers: [
    SlideContentPipelineService,
    GlossaryHtmlService,
    ChaptersFocusModeService
  ],
})
export class SlideBuilderModule {
  static forRoot(config: SlideBuilderConfig): ModuleWithProviders<SlideBuilderModule> {
    return {
      ngModule: SlideBuilderModule,
      providers: [
        { provide: SLIDE_BUILDER_CONFIG, useValue: config }
      ]
    };
  }
}
